import {EScene} from '@/types/scene.types'
import {ESprintenTeam} from '@repo/shared/Customer/Coop/SprintenTeams/SprintenTeams.types'
import {useSetAtom} from 'jotai'
import {useCallback} from 'react'
import {gameStartedState, sceneState} from '../Store/atoms'
import FrameStore from '../Store/FrameStore'
import {generateGameStartedMessage, generateLeaderboardMessage} from './SinglePlayerMode.utils'

const fStore = new FrameStore()

export const useStartSinglePlayerGame = () => {
  const setScene = useSetAtom(sceneState)
  const setGameStarted = useSetAtom(gameStartedState)

  const startSinglePlayerGame = useCallback(() => {
    const leaderboard = fStore.getLeaderboard()

    if (!leaderboard) return

    // update the leaderboard once more with initial data to update start vectors for camera
    const leaderboardMessage = generateLeaderboardMessage({
      team: leaderboard?.leaderboardTeams[0]?.team ?? ESprintenTeam.CoopMega,
      clicks: 0,
      percentage: 0,
    })
    fStore.setLeaderboard(leaderboardMessage)

    // start the single player game
    const gameStartedMessage = generateGameStartedMessage(5)
    setGameStarted(gameStartedMessage)
    setScene(EScene.STARTED_COUNTDOWN)
  }, [])

  return {
    startSinglePlayerGame,
  }
}
